import React, {useState, useRef} from "react";
import {useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";
import TabsMenu from "../../components/TabsMenu";
import {useTranslation} from "react-i18next";
import IdInputField from "../IDInputField/IdInputField";
import "./style.scss";
import {
  setCustomerSlotDetails,
  getCustomerSlotDetails,
} from "../../services/SessionStorage";
import BuSpecificHeader from "../../components/Header/BuSpecificHeader";
import KeyboardComponent from "../../components/Keyboard/Keyboard";
import StoreHeader from "../StoreHeader";

const CustomerInfo = () => {
  const {t} = useTranslation();
  const navigate = useNavigate();

  const customerSlotDetails = useRef(getCustomerSlotDetails());

  const {
    selectedService,
    urlLinkSource,
    showKeyboard,
    isLoggedInUser,
    userIdInput,
  } = useSelector((state) => {
    return {
      selectedService: state.account?.selectedService,
      urlLinkSource: state.globalReducer?.urlLinkSource || null,
      showKeyboard: state.globalReducer?.showKeyboard,
      isLoggedInUser: state.customerReducer?.isLoggedInUser,
      userIdInput: state.customerReducer?.userIdInput,
    };
  });
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
  const [userID, setUserID] = useState(null);
  const countriesWithFormattedId = ["CL", "BR", "UY", "AR"];

  const handleTokenBooking = async () => {
    if (selectedService && userID) {
      customerSlotDetails.current.selectedQueueService = {
        ...selectedService,
        uuid: selectedService.serviceTypeId,
      };
      customerSlotDetails.current.selectedQueueService["from"] = "customerInfo";
      if (
        countriesWithFormattedId?.includes(
          customerSlotDetails?.current?.country
        )
      ) {
        customerSlotDetails.current.userId = userIdInput
          ?.replace(/[^A-Za-z0-9]/g, "")
          .toString();
      } else {
        customerSlotDetails.current.userId = userIdInput;
      }
      setCustomerSlotDetails(customerSlotDetails.current);
      // const datamap = new Map();
      // datamap.set("events", "event15=1");
      // datamap.set("eVar4", selectedService.serviceType);
      // dataDashboard(datamap);
      navigate("/customer/bookQueue", {replace: true});
    }
  };

  const redirectToServiceselection = () => {
    navigate("/customer/selectTurneroStoreAndType");
  };

  return (
    <div className="ci-customer-info-container">
      {urlLinkSource === "web" ? <BuSpecificHeader /> : null}
      {isLoggedInUser && <TabsMenu path="selectTurneroStoreAndType" />}
      <StoreHeader />
      <div className="ci-service-id-wrapper">
        <div className="ci-selected-service-wrap">
          <div className="ci-label-goback-wrap">
            <p className="title">{t("selectedService.text").toUpperCase()}</p>
            <p className="ci-service-name word-break">
              {selectedService?.serviceType}
            </p>
          </div>
          <p className="go-back-text" onClick={redirectToServiceselection}>
            {t("changeService.text")}
          </p>
        </div>
        <IdInputField
          getIsSubmitButtonDisabledAndInput={({
            isSubmitDisabled,
            inputValue,
          }) => {
            setIsSubmitDisabled(isSubmitDisabled);
            if (!isSubmitDisabled) {
              setUserID(inputValue);
            }
          }}
        />
      </div>
      <div className="flex flex-col">
        <button
          className="w-full max-w-[406px] bg-[#343E49] text-white py-[18px] px-8 rounded-[40px] text-base font-semibold hover:bg-opacity-90 transition-colors mt-6"
          disabled={isSubmitDisabled}
          type="submit"
          onClick={handleTokenBooking}
        >
          {t("customerInfoPage.bookTokenBtn")}
        </button>
      </div>
      {showKeyboard && (
        <KeyboardComponent
          country={customerSlotDetails?.country}
          IsSubmitDisabled={isSubmitDisabled}
          onClick={handleTokenBooking}
        ></KeyboardComponent>
      )}
    </div>
  );
};

export default CustomerInfo;
